const PaymentStatusChecker = () => {
    return (  
        <h1>Payment status Checker</h1>
    );
}
 
export default PaymentStatusChecker;